export default __webpack_public_path__ + "static/media/gp stories.b295ff42.svg";